module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Videos_v1.b99be160.svg";